import { createSlice } from "@reduxjs/toolkit";

export const systemLogSlice = createSlice({
  name: "systemLog",
  initialState: {
    getSystemLogResult: false,
    getSystemLogLoading: false,
    getSystemLogError: false,
    addSystemLogResult: false,
    addSystemLogLoading: false,
    deleteSystemLogResult: false,
  },
  reducers: {
    systemLogReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_SYSTEMLOG":
          return {
            ...state,
            getSystemLogResult: payload.data,
            getSystemLogLoading: payload.loading,
            getSystemLogError: payload.error,
          };
        case "ADD_SYSTEMLOG":
          return {
            ...state,
            addSystemLogResult: payload.data,
            addSystemLogLoading: payload.loading,
          };
        case "DELETE_SYSTEMLOG":
          return {
            ...state,
            deleteSystemLogResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { systemLogReducers } = systemLogSlice.actions;

export default systemLogSlice.reducer;
